import { render } from "./SignInIGlow.vue?vue&type=template&id=294371b8"
import script from "./SignInIGlow.vue?vue&type=script&lang=ts"
export * from "./SignInIGlow.vue?vue&type=script&lang=ts"
script.render = render

export default script